import { getLocale } from '@edx/frontend-platform/i18n';

import { ALLOWED_SITE_LANGUAGES, DEFAULT_LANGUAGE } from '../../utils';

/**
 * Resolves the active portal locale to a facilitator guide language. The guide
 * languages exactly match `ALLOWED_SITE_LANGUAGES`, so an unknown locale simply
 * falls back to English.
 */
export const getGuideLanguage = (): string => (
  ALLOWED_SITE_LANGUAGES.includes(getLocale()) ? getLocale() : DEFAULT_LANGUAGE
);
